import { Navigate, useLocation } from 'react-router'

import { usePageTitle } from '../../app/use-page-title'
import * as t from '../../i18n/pt-BR'
import { useSessionStore } from '../../lib/session'
import { homePath } from '../shell/nav'
import { LoginForm } from './login-form'
import { returnToFrom, type ReturnToState } from './return-to'

/**
 * /login. Com sessão, segue para a rota de retorno (ou a primeira área do perfil); com senha
 * temporária, para /trocar-senha guardando o retorno.
 */
export function LoginPage() {
  usePageTitle(t.auth.login.title)
  const location = useLocation()
  const user = useSessionStore((state) => (state.status === 'authenticated' ? state.user : null))

  if (user) {
    const target = returnToFrom(location) ?? homePath(user)
    if (user.mustChangePassword) {
      return (
        <Navigate to="/trocar-senha" replace state={{ from: target } satisfies ReturnToState} />
      )
    }
    return <Navigate to={target} replace />
  }

  return <LoginForm />
}
